export default __webpack_public_path__ + "static/media/supplier-&-user-managementOrange.68244de0.png";